import { ApplicationResultContent } from '../../components/ApplicationResultContent';
import LeftSection from '../../images/Default.png';

export const OrganizationApplicationDeactivated = () => {
  return (
    <ApplicationResultContent
      title='This account has been deactivated.'
      backgroundImage={LeftSection}
      description={
        <div>
          The organization connected to this account is no longer active on MovingWorlds. If you
          believe this is an error or would like to discuss reactivating your account, please
          contact us at{' '}
          <a href='mailto:support@movingworlds.org' className='text-brand-500 underline'>
            support@movingworlds.org
          </a>
          .
        </div>
      }
    />
  );
};
